import { jsx as _jsx } from "react/jsx-runtime";
import { BulletList } from '@tiptap/extension-bullet-list';
import { NodeViewContent, NodeViewWrapper, ReactNodeViewRenderer } from '@tiptap/react';
import { createNodeAdapter } from '../../node';
import { useMemo } from 'react';
export function createBulletListBlockNode(config) {
    const { Component } = config;
    const TiptapComponent = (props) => {
        const adapter = useMemo(() => createNodeAdapter(props), [props]);
        const viewProps = {
            adapter,
        };
        return (_jsx(NodeViewWrapper, { "data-block-id": props.node.attrs.blockId, "data-tiptap-node-id": props.node.attrs.tiptapNodeId, children: _jsx(Component, { ...viewProps, children: _jsx(NodeViewContent, { as: "span" }) }) }));
    };
    return BulletList.extend({
        name: 'bulletList',
        addAttributes() {
            return {
                ...this.parent?.(),
            };
        },
        addNodeView() {
            return ReactNodeViewRenderer(TiptapComponent);
        },
    });
}
//# sourceMappingURL=listBlockExtension.js.map